import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function VerifyPendingPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || "你的信箱";

  return (
    <div style={{
      minHeight: "calc(100vh - 60px)",
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: 24,
    }}>
      <div className="card fade-up" style={{ width: "100%", maxWidth: 480, padding: 48, textAlign: "center" }}>

        <div style={{ fontSize: 56, marginBottom: 24 }}>📬</div>

        <h1 style={{ fontSize: 28, marginBottom: 12 }}>確認你的信箱</h1>

        <p style={{ color: "var(--muted)", lineHeight: 1.7, marginBottom: 8 }}>
          我們已將驗證信寄到
        </p>
        <p style={{ fontWeight: 500, marginBottom: 24, fontSize: 16 }}>
          {email}
        </p>

        <p style={{ color: "var(--muted)", fontSize: 14, lineHeight: 1.7, marginBottom: 32 }}>
          請去信箱點擊驗證連結，驗證完成後即可登入。<br />
          如果沒有收到，請檢查垃圾郵件資料夾。
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <button
            className="btn btn-primary btn-full"
            style={{ height: 48 }}
            onClick={() => navigate("/login")}
          >
            前往登入
          </button>
          <button
            className="btn btn-outline btn-full"
            style={{ height: 48 }}
            onClick={() => navigate("/")}
          >
            回到首頁
          </button>
        </div>

      </div>
    </div>
  );
}
